<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="ok">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
                <b-card header-tag="header">
                  <template #header>
                    <b>Dettagli Generali</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-datepicker
                          vid="book_date"
                          :name="beForm[rep].book_date.label"
                          :label="beForm[rep].book_date.label"
                          v-model="form[rep].book_date"
                          :rules="getRules('book_date')"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          :name="beForm[rep].broker.label"
                          vid="broker_id"
                          :label="beForm[rep].broker.label"
                          v-model="form.broker_id"
                          :options="broker_options"
                          :rules="{ required: true }"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].title.label"
                          vid="title"
                          :label="beForm[rep].title.label"
                          v-model="form[rep].title"
                          :rules="getRules('title')"
                          maxlength="150"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="form-card-wrapper">
                <b-card
                  header="Provvigione del Produttore"
                  header-tag="header"
                  class="mt-1"
                  ><template #header>
                    <b>Provvigione del Produttore</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group mb-3">
                        <b-form-checkbox
                          v-model="isSalerProvTake"
                          name="check-button"
                          switch
                          @change="onChangeSalerProvTake()"
                          >{{
                            !isSalerProvTake
                              ? enable_saler_prov_text
                              : disable_saler_prov_text
                          }}
                        </b-form-checkbox>
                      </div>
                    </b-row>
                    <b-row>
                      <div class="form-group" v-if="isSalerProvTake">
                        <base-currency
                          :name="beForm[rep].saler_prov_take.label"
                          vid="saler_prov_take"
                          label="Importo provvigione"
                          v-model="form[rep].saler_prov_take"
                          :options="{
                            currency: 'EUR',
                            locale: 'it-IT',
                            precision: 2,
                          }"
                          :rules="getRules('saler_prov_take')"
                        />
                      </div>
                      <div class="form-group" v-if="isSalerProvTake">
                        <base-select
                          :name="beForm[rep].is_taxable.label"
                          vid="is_taxable"
                          :label="beForm[rep].is_taxable.label"
                          v-model="form[rep].is_taxable"
                          :options="beForm[rep].is_taxable.options"
                          :rules="{ required: true }"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="form-card-wrapper">
                <b-card header-tag="header">
                  <template #header>
                    <b>Importi</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group mb-3">
                        <b-form-checkbox
                          v-model="isEntryDetails"
                          name="check-button"
                          switch
                          @change="onChangeEntryDetails()"
                          >{{
                            !isEntryDetails
                              ? enable_entry_details_text
                              : disable_entry_details_text
                          }}
                        </b-form-checkbox>
                      </div>
                    </b-row>
                    <b-row>
                      <div class="form-group mb-3" v-if="isEntryDetails">
                        <base-currency
                          :name="beForm[rep].net.label"
                          vid="net"
                          label="Imponibile"
                          v-model="form[rep].net"
                          :options="{
                            currency: 'EUR',
                            locale: 'it-IT',
                            precision: 2,
                          }"
                          :rules="getRules('net')"
                        />
                      </div>
                      <div class="form-group" v-if="isEntryDetails">
                        <base-currency
                          :name="beForm[rep].gross.label"
                          vid="gross"
                          :label="beForm[rep].gross.label"
                          v-model="form[rep].gross"
                          :options="{
                            currency: 'EUR',
                            locale: 'it-IT',
                            precision: 2,
                          }"
                          :rules="{
                            required: true,
                            compare_numbers: {
                              otherValues: ['0'],
                              operator: '!=',
                            },
                          }"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="form-actions form-actions--sticky">
                <div class="inner-wrapper">
                  <div>
                    <span
                      :title="`${
                        invalid
                          ? 'Compila correttamente i campi per poter salvare'
                          : 'Invia il form'
                      }`"
                    >
                      <b-button
                        @click="handleSubmit(onSubmit)"
                        type="button"
                        :disabled="invalid"
                        variant="lisaweb"
                        size="sm"
                        :title="`${
                          invalid
                            ? 'Compila correttamente i campi per poter salvare'
                            : 'Invia il form'
                        }`"
                      >
                        Salva
                      </b-button>
                    </span>
                  </div>
                  <div>
                    <b-button
                      @click="goBack()"
                      class="btn--transparent"
                      type="button"
                      title="Torna alla pagina precedente"
                    >
                      <b-icon-chevron-double-left
                        font-scale="0.9"
                      ></b-icon-chevron-double-left>
                      Torna indietro
                    </b-button>
                  </div>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          {{ errorMessage }}
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import BaseCurrency from "@/components/form/BaseCurrency";
import BaseInput from "@/components/form/BaseInput";
import EntryDetailsMixin from "@/mixins/EntryDetailsMixin";
import FormMixin from "@/mixins/FormMixin";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import { toLocaleCurrency } from "@/utils/strings";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  mixins: [FormMixin, EntryDetailsMixin, ShortcutMixin],
  data() {
    return {
      isLoading: false,
      //Switch Flags
      isSalerProvTake: false,
      isEntryDetails: false,
      //Switch Texts
      disable_saler_prov_text: "Disabilita la provvigione del produttore",
      enable_saler_prov_text: "Abilita la provvigione del produttore",
      disable_entry_details_text: "Disabilita l'importo",
      enable_entry_details_text: "Abilita l'importo",
      repository: "book_entry",
      id: this.$route.params.id,
      item: this.$route.params.item,
      treasury_options: [],
      treasuries: [],
      onlyRealTreasuries: true,
      skipTreasuries: this.getExcludedTreasuries()("OTHER"),
      entryDetails: [],
      broker_options: [],
      form: {
        broker_id: null,
        book_entry: {
          insurance_policy_number: null,
          book_date: moment().format("YYYY-MM-DD"),
          effective_date: null,
          registry: {},
          mandate_code_id: null,
          is_taxable: null,
          title: null,
          broker: {},
          insurer_id: null,
          net: 0.0,
          tax: 0.0,
          gross: 0.0,
          agency_prov_take: 0.0,
          agency_prov_purchase: 0.0,
          saler_prov_take: 0.0,
          saler_prov_purchase: 0.0,
          various_accounting: {
            2: {},
          },
        },
        entry_detail: {
          book_entry_id: null,
          treasury_id: null,
          gross: null,
          detail_date: null,
        },
        book_entries: {
          entry_details: {},
        },
      },
    };
  },
  methods: {
    toLocaleCurrency,
    goBack() {
      if (this.returnUrl) {
        switch (this.returnUrl) {
          case "accounting-book":
            this.$router.push({
              name: "module.CONT.FQUA",
              params: {
                onLandData: {
                  date_from:
                    "date_from" in this.returnData
                      ? this.returnData.date_from
                      : null,
                },
              },
            });
            break;
          default:
            console.log(
              "No returnUrl set matched! Fallback to default back behavior.",
            );
            this.$router.back();
            break;
        }
      } else {
        this.$router.back();
      }
    },
    initDefaultFormValues() {
      // this.form.book_entry.is_taxable = "N";
      this.isSalerProvTake = this.form[this.rep].saler_prov_take ? true : false;
      this.isEntryDetails =
        this.form[this.rep].gross || this.form[this.rep].net ? true : false;
    },
    initDefaultValues() {
      // Produttori
      this.broker_options = this.getSalesmen();
      this.form.broker_id = this.item.brokers.length
        ? this.item.brokers[0].id
        : null;
      // enable treasuries
      // this.onlyRealTreasuries = true;
      this.editEntryDetailsCompToggle = true; // REVIEW: workaround per disegnare la forma di pagamento vuota
    },
    onSubmit() {
      /**
       * promise.all: salva book_entries (Dettagli Generali + Provvigioni Produttore) e entry_details
       *
       * NOTA: i vari check, li fa PREVENTIVAMENTE alla promise.all
       *
       */
      // checks
      // TODO: effettuare il controllo se le forme di pagamento sono effettivamente abilitate...(isEntryDetails???)
      // if (this.isEntryDetails && this.details.gross !== this.sumEntryDetails) {
      // if (
      //   this.isEntryDetails &&
      //   this.form[this.rep].gross != this.entryDetailsEditTotal
      // ) {
      //   this.$showSnackbar({
      //     preset: "error",
      //     text: `La somma delle forme di pagamento deve essere uguale al lordo`,
      //   });
      //   return;
      // }
      const sbep = this.submitBookEntryPromise();

      this.isLoading = true;
      Promise.all([sbep])
        .then(() => {
          this.onSuccess();
          this.isLoading = false;
          // this.refreshData();
        })
        .catch((error) => {
          this.onFailure(error);
          this.isLoading = false;
        });
    },
    submitBookEntryPromise() {
      this.setFormValues();
      // console.debug("Form: ", this.form[this.rep]);
      // Modifica il foglio cassa
      return this.update(this.repository, this.id);
    },
    setFormValues() {
      this.form[this.rep].effective_date = this.form[this.rep].book_date;
      // Anagrafica
      this.form[this.rep].registry = this.form.registry
        ? { [this.form.registry]: {} }
        : {};
      // Produttore
      this.form[this.rep].broker = this.form.broker_id
        ? { [this.form.broker_id]: {} }
        : {};
      // Tipologia di movimento Contabile
      if (this.isVariousAccounting) {
        const book_entry_id = this.item.various_accountings[0].id;
        this.form[this.rep]["various_accounting"] = {
          [book_entry_id]: {
            insurance_risk_id:
              this.item.various_accountings[0].pivot.insurance_risk_id,
          },
        };
      }
      if (
        this.item.insurance_ancillaries &&
        this.item.insurance_ancillaries.length
      ) {
        const insurance_ancillary_id = this.item.insurance_ancillaries[0].id;
        this.form[this.rep]["insurance_ancillary"] = {
          [insurance_ancillary_id]: {},
        };
      }
    },
    onChangeSalerProvTake() {
      if (!this.isSalerProvTake) {
        this.form[this.rep].saler_prov_take = 0.0;
      }
    },
    onChangeEntryDetails() {
      if (!this.isEntryDetails) {
        this.deleteAll();
        this.form[this.rep].gross = 0.0;
        this.form[this.rep].net = 0.0;
      }
    },
    deleteAll() {
      for (let d of this.dtls.filter((dtl) => dtl.selected)) {
        this.deleteCreateEntryDetail(
          this.form.book_entries.entry_details,
          d.id,
        );
      }
    },
    onSuccess() {
      this.$showSnackbar({
        preset: "success",
        text: `Azione Completata: Movimento Contabile Creato (II)`,
      });
      this.shortcut("module.CONT.CONP", null, null, "filterVariousAccounting");
    },
    onFailure(error) {
      let errMsg = this.$getErrorMessage(error);
      this.$showSnackbar({
        preset: "error",
        text: `${errMsg}`,
      });
    },
    // toCurrency(value) {
    //   if (!value) value = "0.00001";
    //   return toLocaleCurrency(parseFloat(value));
    // },
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
      // getTreasuries: "treasuries",
      getExcludedTreasuries: "excludedTreasuries",
    }),
  },
  components: {
    BaseSelect,
    BaseDatepicker,
    BaseCurrency,
    BaseInput,
    // EntryDetails,
  },
  computed: {
    rep() {
      return this.repository;
    },
    isVariousAccounting() {
      return this.item.various_accountings &&
        this.item.various_accountings.length
        ? true
        : false;
    },
    entryDetailsEditTotal() {
      return Object.keys(this.form.book_entries.entry_details)
        .map((key) => {
          return +this.form.book_entries.entry_details[key].amount || 0;
        })
        .reduce(function (sum, i) {
          return sum + i;
        }, 0);
    },
  },
  beforeMount() {
    // this.treasury_options = this.getTreasuries()();
    this.broker_options = this.getSalesmen();
  },
  mounted() {
    // this.initCreateEntryDetail(this.form.book_entries.entry_details);
    // this.initDefaultFormValues();
  },
  created() {
    this.isLoading = true;
    // const be = this.fetchCreateForm(this.repository);
    const be = this.fetchEditForm(this.repository, this.id);

    Promise.all([be])
      .then(() => {
        this.initDefaultFormValues();
        this.initDefaultValues();
        this.entryDetails = this.item.entry_details;
        this.changeEntryDetails(this.form.book_entries.entry_details);
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({ preset: "error", text: errMsg });
      })
      .finally(() => {
        this.isLoading = false;
      });
    // oppure risparmiano la chiamata "ed" utilizzo la rule sul gross di "be", anche se non è la stesso campo...
    /* this.fetchEditForm(this.repository, this.id).then(() => {
      this.initDefaultFormValues();
      this.initDefaultValues();
      this.entryDetails = this.item.entry_details;
      this.changeEntryDetails(this.form.book_entries.entry_details);
      this.isLoading = false;
    }); */
  },
};
</script>
